import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Modal,
  Button,
  Table,
  Form,
  Input,
  Select,
  AutoComplete,
  message,
  Upload,
  Radio,
  Empty,
  Switch,
  Checkbox,
  InputNumber
} from "antd";
import { FilterDropdown } from "antd/lib/table/hooks/useFilter";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import slugify from "slugify";
import CloseButton from "../components/CloseButton";
import "./SetCategory.css";
import imageCompression from "browser-image-compression";
import { UploadOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import { jwtDecode } from "jwt-decode";
import { Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import {
  DeleteOutlined,
  EditOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";
import config from "../config";

const { TextArea } = Input;
const ProductsTable = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [form] = Form.useForm();
  const [itemsData, setItemsData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [categoryFilters, setCategoryFilters] = useState([]);
  const [newPid, setNewPid] = useState("");
  const [printerStatusOpen, setPrinterStatusOpen] = useState(false);
  const [printersData, setPrintersData] = useState([]);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [productIconOpen, setProductIconOpen] = useState(false);
  const [tableDisableList, setTableDisableList] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileUpload, setFile] = useState(null);
  const [previousImageKey, setPreviousImageKey] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [originalImage, setOriginalImageURLEdit] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadTimeout, setUploadTimeout] = useState(null);
  var [countImageUploaded, setCountImage] = useState(0);
  const [subMenu, setSubMenu] = useState([]);
  const [subMenuGroup, setSubMenuGroup] = useState("");
  const [subMenuItem, setSubMenuItem] = useState([]);
  const [subMenuSelectionType, setSubMenuSelectionType] = useState("");
  const [subMenuShowType, setSubMenuShowType] = useState("");
  const [subMenuRequirement, setSubMenuRequirement] = useState("");
  const [subMenuPrinter, setSubMenuPrinter] = useState([]);
  const [isSubMenuPrintEnabled, setIsSubMenuPrintEnabled] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isItemEditing, setIsItemEditing] = useState(false);
  const [editingItemIndex, setEditingItemIndex] = useState(null);
  const [editSubMenuGroup, setEditSubMenuGroup] = useState("");
  const [editItemName, setEditItemName] = useState("");
  const [editItemPrice, setEditItemPrice] = useState("");
  const [editSubMenuSelectionType, setEditSubMenuSelectionType] = useState("");
  const [editSubMenuShowType, setEditSubMenuShowType] = useState("");
  const [editSubMenuPrinter, setEditSubMenuPrinter] = useState([]);
  const [editSubMenuRequirement, setEditSubMenuRequirement] = useState("");
  const [subMenuModalVisible, setSubMenuModalVisible] = useState(false);
  const [itemModalVisible, setItemModalVisible] = useState(false);
  const [newItemName, setNewItemName] = useState("");
  const [newItemPrice, setNewItemPrice] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [addItemMode, setAddItemMode] = useState("custom"); // "custom" or "category"
  const [selectedMenuItem, setSelectedMenuItem] = useState(null); // Track selected menu item
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);
  const [searchText, setSearchText] = useState("");
  const [filteredItemsData, setFilteredItemsData] = useState([]);
  const { Search } = Input;
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [icons, setIcons] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const [editItemMode, setEditItemMode] = useState("custom");
  const [editSelectedCategory, setEditSelectedCategory] = useState(null);
  const [editDropdownOpen, setEditDropdownOpen] = useState(false);
  const [selectedEditMenuItem, setSelectedEditMenuItem] = useState(null);
  const [newCustomUnit, setNewCustomUnit] = useState("");
  const [editCustomUnit, setEditCustomUnit] = useState("");
  const [uom, setUom] = useState('');

  const openAddItemModal = () => {
    setItemModalVisible(true);
  };

  const handlePrinterStatusDropdownVisibleChange = (open) => {
    setPrinterStatusOpen(open);
  };

  const getAllPrinter = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      setPrintersData(data.printerSettings);
      // console.log(data);
    } catch (error) {
      message.error('Something Went Wrong');
      // console.log(error);
    }
  };

  const handleAddItem = () => {
    if (addItemMode === "category") {
      // Adding items from selected category
      if (!selectedCategory) {
        message.error("Please select a category.");
        return;
      }

      const categoryItems = getItemsBySelectedCategory();
      if (categoryItems.length === 0) {
        message.error("No items found in the selected category.");
        return;
      }

      // Add all items from the selected category
      const newItems = categoryItems.map(item => ({
        id: item._id, // Use _id as the main ID for category items
        name: item.name,
        price: 0, // Default price for category items
        slug: item.slug || item.name,
        customUnit: item.customUnit,
        pid: item.pid, // Preserve product ID for inventory tracking
        _id: item._id, // Preserve MongoDB ID
        isCategoryItem: true // Flag to identify category items
      }));

      // Check for duplicates
      const existingNames = subMenuItem.map(item => item.name);
      const duplicates = newItems.filter(item => existingNames.includes(item.name));

      if (duplicates.length > 0) {
        message.error(`Some items already exist: ${duplicates.map(d => d.name).join(', ')}`);
        return;
      }

      setSubMenuItem((prevItems) => [...prevItems, ...newItems]);
      message.success(`Added ${newItems.length} items from ${selectedCategory} category`);

    } else {
      // Adding custom item or selected menu item
      if (newItemName === "") {
        message.error("Please enter a name.");
        return;
      } else if (newItemPrice === "" || isNaN(newItemPrice) || newItemPrice < 0) {
        message.error("Price should be min 0");
        return;
      }

      const exists = subMenuItem.some((item) => item.name === newItemName);

      if (exists) {
        message.error("The name is already existed in the items.");
        return;
      }

      let newItem;
      if (selectedMenuItem) {
        // User selected from existing menu items
        newItem = {
          id: selectedMenuItem._id, // Use _id as main ID for menu items
          name: selectedMenuItem.name,
          price: newItemPrice, // Use user-entered price (could be overridden)
          customUnit: newCustomUnit,
          slug: selectedMenuItem.slug || selectedMenuItem.name,
          pid: selectedMenuItem.pid, // Preserve product ID for inventory tracking
          _id: selectedMenuItem._id, // Preserve MongoDB ID
          isCategoryItem: true // Flag to identify menu items
        };
      } else {
        // User entered custom option
        newItem = {
          id: Date.now(),
          name: newItemName,
          price: newItemPrice,
          customUnit: newCustomUnit,
        };
      }

      setSubMenuItem((prevItems) => [...prevItems, newItem]);
    }

    // Reset form
    setNewItemName("");
    setNewItemPrice("");
    setNewCustomUnit("");
    setSelectedCategory("");
    setAddItemMode("custom");
    setSelectedMenuItem(null);
    setDropdownOpen(false);
    setItemModalVisible(false);
  };

  //refresh order item quantity after place order
  useEffect(() => {
    const handleRefresh = () => {
      getAllItems();
    };
    window.addEventListener('refreshItems', handleRefresh);
    return () => window.removeEventListener('refreshItems', handleRefresh);
  }, []);

  const handleCancelItemModal = () => {
    setNewItemName("");
    setNewItemPrice("");
    setNewCustomUnit("");
    setItemModalVisible(false);
  };

  const getUniqueCategories = () => {
    const uniqueCategories = [...new Set(itemsData.map(item => item.category))];
    return uniqueCategories.filter(category => category && category.trim() !== "");
  };

  const getItemsBySelectedCategory = () => {
    if (!selectedCategory) return [];
    return itemsData.filter(item => item.category === selectedCategory);
  };

  const handleSubMenuGroupChange = (event) => {
    setSubMenuGroup(event.target.value);
  };

  const handleSubMenuSelectionTypeChange = (event) => {
    setSubMenuSelectionType(event.target.value);
  };

  const handleSubMenuShowTypeChange = (event) => {
    setSubMenuShowType(event.target.value);
  };

  const handleSubMenuRequirementChange = (event) => {
    setSubMenuRequirement(event.target.value);
  };

  const handleSubMenuPrinterChange = (value) => {
    setSubMenuPrinter(value);
  };

  const openEditModal = (id) => {
    // console.log('id: ', id);
    // console.log('isSubMenuPrintEnabled: ', isSubMenuPrintEnabled);

    const item = subMenu.find((subMenu) => subMenu.id === id);
    // console.log('item: ', item);
    // console.log('subMenu: ', subMenu);

    if (!item) {
      console.error(`Item with ID ${id} not found`);
      return;
    }
    setEditingIndex(item.id);
    setEditSubMenuGroup(item.group);
    setSubMenuItem(item.items);
    setEditSubMenuSelectionType(item.selection);
    setEditSubMenuShowType(item.show);
    setEditSubMenuRequirement(item.requirement);
    setEditSubMenuPrinter(item.printer ? (Array.isArray(item.printer) ? item.printer : [item.printer]) : []);
    setIsEditing(true);
  };

  const openEditItemModal = (id) => {
    const item = subMenuItem.find((subMenuItem) => subMenuItem.id === id);

    if (!item) {
      console.error(`Item with ID ${id} not found.`);
      return;
    }

    //console.log("Id", item);
    setEditingItemIndex(item.id);
    setEditItemName(item.name);
    setEditItemPrice(item.price);
    setEditCustomUnit(item.customUnit);
    setIsItemEditing(true);
  };

  const handleEditItemSave = () => {

    if (editItemName === "") {
      message.error("Please enter a name.");
      return;
    }

    if (editItemPrice === "" || isNaN(editItemPrice) || editItemPrice < 0) {
      message.error("Price should be min 0");
      return;
    }

    const exists = subMenuItem.some(
      (item) => item.name === editItemName && item.id !== editingItemIndex
    );
    if (exists) {
      message.error("The name is already existed in the items.");
      return;
    }
    const updatedItems = subMenuItem.map((item) =>
      item.id === editingItemIndex
        ? { ...item, name: editItemName, price: editItemPrice, customUnit: editCustomUnit }
        : item
    );
    setSubMenuItem(updatedItems);
    setIsItemEditing(false);
    setEditingItemIndex(null);
  };

  const handleEditModalSave = () => {
    // console.log('subMenu in edit modal: ', subMenu);
    // console.log('editingIndex: ', editingIndex);

    if (editSubMenuGroup === "") {
      message.error("Please enter a group for the submenu item.");
    } else if (subMenuItem.length === 0) {
      message.error("Item should not be empty.");
    } else if (editSubMenuSelectionType === "") {
      message.error("Please choose a selection type.");
    } else if (editSubMenuShowType === "") {
      message.error("Please choose a show type.");
    } else if (editSubMenuRequirement === "") {
      message.error("Please choose a requirement.");
    } else if (editSubMenuPrinter.length === 0 && isSubMenuPrintEnabled) {
      message.error("Please choose a printer.");
    } else {
      const exists = subMenu.some((item) => item.group === editSubMenuGroup && item.id !== editingIndex);
      // console.log('subMenu: ', subMenu);

      if (exists) {
        message.error("The group is already existed in the sub menu.");
        return;
      }

      const updatedItems = subMenu.map((item) =>
        item.id === editingIndex
          ? {
            ...item,
            group: editSubMenuGroup,
            items: subMenuItem,
            selection: editSubMenuSelectionType,
            show: editSubMenuShowType,
            requirement: editSubMenuRequirement,
            printer: editSubMenuPrinter,
          }
          : item
      );
      setSubMenu(updatedItems);
      setIsEditing(false);
      setEditingIndex(null);
      setSubMenuItem([]);
      setEditSubMenuPrinter([]);
    }
  };

  const openSubMenuModal = () => {
    setSubMenuItem([]);
    setSubMenuModalVisible(true);
  };

  const handleSubMenuSubmit = () => {
    if (subMenuGroup === "") {
      message.error("Please enter a group for the submenu item.");
    } else if (subMenuItem.length === 0) {
      message.error("Item should not be empty.");
    } else if (subMenuSelectionType === "") {
      message.error("Please choose a selection type.");
    } else if (subMenuShowType === "") {
      message.error("Please choose a show type.");
    } else if (subMenuRequirement === "") {
      message.error("Please choose a requirement.");
    } else if (subMenuPrinter.length === 0 && isSubMenuPrintEnabled) {
      message.error("Please choose a printer.");
    } else {
      const exists = subMenu.some((item) => item.group === subMenuGroup);

      if (exists) {
        message.error("The group is already existed in the sub menu.");
        return;
      }

      const newItem = {
        id: Date.now(),
        group: subMenuGroup,
        items: subMenuItem,
        selection: subMenuSelectionType,
        show: subMenuShowType,
        requirement: subMenuRequirement,
        printer: subMenuPrinter,
      };

      // console.log('Creating new submenu group:', newItem);
      // console.log('Submenu items being saved:', subMenuItem);

      setSubMenu([...subMenu, newItem]);
      setSubMenuGroup("");
      setSubMenuItem([]);
      setSubMenuSelectionType("");
      setSubMenuShowType("");
      setSubMenuRequirement("");
      setSubMenuPrinter([]);
      setSubMenuModalVisible(false);
    }
  };

  const handleCategoryDropdownVisibleChange = (open) => {
    setCategoryOpen(open);
  };

  const handleProductIconDropdownVisibleChange = (open) => {
    setProductIconOpen(open);
  };

  const handleTableDisableListVisibleChange = (open) => {
    setTableDisableList(open);
  }

  const handleStatusDropdownVisibleChange = (open) => {
    setStatusOpen(open);
  };
  const handleCategoryFilter = (value, record) => {
    return record.category === value;
  };

  const handleCategoryFiltersChange = (filters) => {
    setCategoryFilters(filters);
  };
  const getAllItems = async () => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/products/get-product`
      );

      setItemsData(data);
      setFilteredItemsData(data);
      //console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllCategories = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/menus/get-category`);
      setCategories(data);
    } catch (error) {
      console.log(error);
    }
  };
  // useEffect(() => {
  //   if (searchText) {
  //     setFilteredItemsData(
  //       itemsData.filter(
  //         (item) =>
  //           item.name.toLowerCase().includes(searchText.toLowerCase()) ||
  //           item.category.toLowerCase().includes(searchText.toLowerCase())
  //       )
  //     );
  //   } else {
  //     setFilteredItemsData(itemsData);
  //   }
  // }, [searchText]);





  useEffect(() => {
    fetchIcons();
    getAllItems();
    getAllCategories();
    getAllPrinter();
    fetchTable();
  }, []);

  const fetchIcons = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/icons/get`);
      setIcons(data);
      //console.log(data)
    } catch (error) {
      console.error("Error fetching icons:", error);
    }
  };

  const fetchTable = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/tables/get-table`);
      setTableList(data);
      console.log("table", data);
    } catch (error) {
      console.error("error fetch Table", error);
    }
  }

  const handleSearch = (searchValue) => {
    const lowerSearch = searchValue.toLowerCase();

    if (searchValue) {
      const filtered = itemsData.filter(item =>
        item.name.toLowerCase().includes(lowerSearch) ||
        item.category.toLowerCase().includes(lowerSearch)
      );
      setFilteredItemsData(filtered);
    } else {
      setFilteredItemsData(itemsData);
    }
  };

  useEffect(() => {
    // This effect will run when the editCategory is set (when fetching data for editing)
    if (editItem && editItem.image) {
      // If there's an existing image, set it as the initial image
      const extractedFilename = editItem.image.match(/[^/]+$/)[0];
      setImageUrl(editItem.image);
      setPreviousImageKey(new URL(editItem.image).pathname.slice(1)); // Extract the key from the URL
      // Initialize the fileList with the fetched image (for display in the Upload component)
      setFileList([
        {
          uid: "-1", // Unique identifier for the file
          name: extractedFilename, // Display name
          status: "done", // Mark it as uploaded
          url: editItem.image, // Set the fetched image URL
        },
      ]);
    }
  }, [editItem]);

  //able data
  const columns = [
    // {
    //   title: "No",
    //   key: "index",
    //   render: (text, record, recordIndex) => (
    //     <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
    //   ),
    // },
    {
      title: "Image",
      dataIndex: "image",
      render: (image, record) => (
        // <img src={record.image} alt={record.name} height="50" width="50" />
        <img
          src={record.image}
          alt={record.name}
          height="50"
          width="50"
          style={{ cursor: 'pointer', borderRadius: 6, objectFit: 'cover' }}
          onClick={() => {
            setPreviewImage(record.image);
            setPreviewVisible(true);
          }}
        />
      ),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 150,
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Product Icon",
      dataIndex: "productIcon",
      filters: icons.map((icon) => ({
        text: icon.iconName,
        value: icon.iconName,
      })),
      onFilter: (value, record) => {
        return record.productIcon?.some(icon => icon.iconName === value);
      },
      render: (productIcons) => {
        if (!productIcons?.length) return "NIL";
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {productIcons.map((icon, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <i
                  className={icon.faIcon}
                  style={{ color: icon.iconColor, fontSize: 16 }}
                />
                <span>{icon.iconName}</span>
              </div>
            ))}
          </div>
        );
      },
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      width: 150,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Category",
      dataIndex: "category",
      filters: categories.map((category) => ({
        text: category.name,
        value: category.name,
      })),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={categories.map(c => ({ label: c.name, value: c.name }))}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      onFilter: (value, record) => record.category === value,
    },
    {
      title: "Sub Menu",
      dataIndex: "subMenu",
      width: 450,
      render: (subMenu, record) => {
        if (!subMenu || subMenu.length === 0) {
          return null;
        }

        const groupedSubMenu = subMenu.reduce((acc, item) => {
          if (item.group && item.items && item.items.length > 0) {
            if (!acc[item.group]) {
              acc[item.group] = [];
            }
            acc[item.group].push(...item.items);
          }
          return acc;
        }, {});

        return (
          <ul>
            {Object.entries(groupedSubMenu).map(([group, items]) => (
              <li key={group}>
                <strong>{group}</strong>
                <ul>
                  {items.map((item) => (
                    <li key={item.id}>
                      {item.name} : {symbol} {parseFloat(item.price).toFixed(2)}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        );
      },
    },
    {
      title: "Price (" + symbol + ")",
      dataIndex: "price",
      sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price),
      showSorterTooltip: false,
      render: (price) => `${parseFloat(price).toFixed(2)}`,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Max Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => (parseInt(a.quantity) || 0) - (parseInt(b.quantity) || 0),
      showSorterTooltip: false,
      // render: (quantity) => quantity ?? "NIL",
      render: (quantity, record) => {
        if (quantity == null) return "NIL";
        const uom = record.uom ? ` ${record.uom}` : "";
        return `${quantity}${uom}`;
      },
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Discountable",
      dataIndex: "discountAble",
      render: (discountAble) => (discountAble ? "Yes" : "No"),
      filters: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.discountAble === value,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Availability",
      dataIndex: "status",
      render: (status, record) => (
        <div>
          <Switch
            className="fixed-switch"
            checked={status}
            onChange={(checked) => handleStatusToggle(checked, record)}
            checkedChildren="Yes"
            unCheckedChildren="No"
          />
          {/* maxquantity=0, show outofstock label */}
          {record.quantity === 0 && (
            <div
              style={{
                marginTop: 6,
                color: '#ff4d4f',
                fontWeight: 600,
                fontSize: 13,
                background: '#fff1f0',
                borderRadius: 4,
                padding: '2px 8px',
                display: 'inline-block'
              }}
            >
              Out of Stock
            </div>
          )}
          {/* quantity=null/undefined/"NIL", show unlimited stock */}
          {(record.quantity == null || String(record.quantity).toUpperCase() === "NIL") && (
            <div
              style={{
                marginTop: 6,
                color: '#52c41a',
                fontWeight: 600,
                fontSize: 13,
                background: '#f6ffed',
                borderRadius: 4,
                padding: '2px 8px',
                display: 'inline-block'
              }}
            >
              Unlimited Stock
            </div>
          )}
        </div>
      ),
      filters: [
        { text: "Available", value: true },
        { text: "Not Available", value: false },
        { text: "Out of Stock", value: "outofstock" },
        { text: "Unlimited Stock", value: "unlimited" },
      ],
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Available', value: true },
              { label: 'Not Available', value: false },
              { label: 'Out of Stock', value: 'outofstock' },
              { label: "Unlimited Stock", value: "unlimited" }
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => {
        if (value === true) return record.status === true;
        if (value === false) return record.status === false;
        if (value === "outofstock") return record.quantity === 0;
        if (value === "unlimited") return record.quantity == null || String(record.quantity).toUpperCase() === "NIL";
        return true;
      },
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div className="actions-column">
          <EditOutlined
            style={{
              cursor: "pointer", fontSize: 22
            }}
            onClick={() => openModal(record)}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ cursor: "pointer", fontSize: 22, marginLeft: 8 }} />
          </Popconfirm>
        </div>
      ),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
  ];
  //handle name change
  const handleNameChange = (event) => {
    const { value } = event.target;
    form.setFieldsValue({ slug: slugify(value) });
  };

  const deleteImageFromS3 = async (key) => {
    // console.log("Deleting key:", key); // Debug
    if (!key) {
      console.error("No key provided for deletion");
      return; // Prevent calling the API with a null/undefined key
    }
    try {
      // console.log("Start Perform API");
      // await axios.post("${apiBaseUrl}/api/delete", {
      //   data: { key },
      // });
      await axios.post(
        `${apiBaseUrl}/api/image/delete`,
        { key },
        {
          headers: {
            "Content-Type": "application/json", // Ensure JSON payload
          },
        }
      );
      // console.log("Done.");
      // message.success("Image deleted successfully");
    } catch (error) {
      // console.error("Failed to delete image:", error);
      // console.error("Failed to delete image. Error:", error.response?.data || error.message);
      // message.error("Failed to delete image");
      //
    }
  };

  const openModal = (item = null) => {
    if (item) {
      setEditItem(item); // Set the category to edit
      setImageUrl(item.image); // Set the existing image URL
      // console.log(" Image",imageUrl);
      setPreviousImageKey(new URL(item.image).pathname.slice(1)); // Extract S3 key from URL
      setOriginalImageURLEdit(item.image);
      // console.log("Original Image",originalImage);
      // Populate the fileList with the existing image
      setFileList([
        {
          uid: "-1", // Unique identifier for the file
          name: "Existing Image", // Display name
          status: "done", // Mark it as uploaded
          url: item.image, // Existing image URL
        },
      ]);
      setSubMenu(item.subMenu || []);
      setIsSubMenuPrintEnabled(item.isSubMenuPrint);
    } else {
      setEditItem(null); // For adding a new category
      setImageUrl(null); // Clear image URL
      setPreviousImageKey(null); // Clear the previous image key
      setOriginalImageURLEdit(null);
      setFileList([]); // Clear the file list
      setSubMenu([]);
      setSubMenuGroup("");
      setSubMenuItem([]);
      setSubMenuSelectionType("");
      setSubMenuShowType("");
      setSubMenuRequirement("");
      setSubMenuPrinter("");
      setIsSubMenuPrintEnabled(false);

    }

    setPopupModal(true); // Open the modal
  };

  const handleDeleteSubMenu = (id) => {
    const newSubMenu = subMenu.filter((item) => item.id !== id);
    setSubMenu(newSubMenu);
  };

  const handleDeleteItem = (id) => {
    const newItem = subMenuItem.filter((item) => item.id !== id);
    setSubMenuItem(newItem);
  };

  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth?.token) {
      try {
        const decoded = jwtDecode(auth.token);
        setCurrentUser(decoded.userId); // Just set userId
        //console.log(decoded.userId)
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
      }
    }
  }, []);

  //handle submit
  const handleSubmit = async (value) => {
    if (isUploading) {
      message.warning(
        "Please wait until the upload is complete before submit your form."
      );
      return false; // Prevent the removal
    }

    setLoading(true);

    const { name } = value;

    let slug;
    let productIcon;
    // const selectedIcon = icons.find(icon => icon._id === value.productIcon);
    const selectedIcons = icons.filter(icon => value.productIcon.includes(icon._id));


    if (editItem === null) {
      const res = await axios.get(`${apiBaseUrl}/api/products/latest-pid`);
      const latestPid = res.data.pid;
      const newPid =
        "P" + String(parseInt(latestPid.slice(1)) + 1).padStart(7, "0");

      try {
        const dateTime = new Date();
        const createdAt = dateTime.toLocaleString();

        const auth = JSON.parse(localStorage.getItem("auth"));
        const decoded = auth?.token ? jwtDecode(auth.token) : null;
        const userId = decoded?.userId || currentUser || "Unknown";
        //console.log("User", userId)

        slug = value.slug;

        const newValues = {
          ...value,

          pid: newPid,
          createdAt,
          image: imageUrl || null,
          subMenu: subMenu,
          productIcon: selectedIcons || null,
          userId: userId || null
        };

        if (fileUpload !== null) {
          try {
            const uploadedImageUrl = await uploadImageToS3(fileUpload);
            newValues.image = uploadedImageUrl;
            //console.log("See new value:", newValues.image);
          } catch (uploadError) {
            // If image upload fails, clear the file list and stop submission
            message.error("Image upload failed. Please try again.");
            setLoading(false);
            setFile(null);
            setFileList([]); // Clear the file list
            return; // Stop the submission process
          }
        }

        if (subMenu && newValues.isSubMenuPrint) {
          const isMissingPrinter = subMenu.filter((item) => !item.printer);
          if (isMissingPrinter.length > 0) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "There is sub menu without selecting printer",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            return;
          }
        }

        const res = await axios.post(
          `${apiBaseUrl}/api/products/add-product`,
          newValues
        );
        // message.success('Food Added Successfully')
        Swal.fire({
          title: "Success",
          text: "Food/Drink Added Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllItems();
        setCountImage(0);
        setOriginalImageURLEdit(null);
        setImageUrl(null);
        setPopupModal(false);
        setFileList([]);
        setSubMenu([]);

      } catch (error) {
        // message.success('Something Went Wrong')
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something Went Wrong",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        // console.log(imageUrl);
        // console.log(originalImage);
        // let finalImageUrl = "";
        // if (imageUrl !== originalImage && setFileList!=null) {
        //   // Delete the old image from S3 if the image URL has changed
        //   // console.log("Try here before...");
        //   const previousImageKey = originalImage.split('/').pop();
        //   await deleteImageFromS3(previousImageKey);
        //   finalImageUrl = imageUrl;
        // }
        // if ((imageUrl == null && originalImage) || (imageUrl && originalImage != null)) {
        //   setCountImage(0);
        //   // updatedValues.image = originalImage; // Update `updatedValues` directly
        //   finalImageUrl = originalImage;
        //   setImageUrl(finalImageUrl);
        // }

        let finalImageUrl = "";
        if (imageUrl !== originalImage && imageUrl != null) {
          try {
            finalImageUrl = await uploadImageToS3(fileUpload);
          } catch (uploadError) {
            // If image upload fails, clear the file list and stop submission
            message.error("Image upload failed. Please try again.");
            setLoading(false);
            setFile(null);
            setFileList([]); // Clear the file list
            return; // Stop the submission process
          }
        } else {
          finalImageUrl = imageUrl;
        }

        const auth = JSON.parse(localStorage.getItem("auth"));
        const decoded = auth?.token ? jwtDecode(auth.token) : null;
        const userId = decoded?.userId || currentUser || "Unknown";
        //console.log("User", userId)

        slug = value.slug;

        if (subMenu && value.isSubMenuPrint) {
          subMenu.forEach((item) => {
            //console.log(item.printer);            
          })

          const isMissingPrinter = subMenu.filter((item) => !item.printer || item.printer.length === 0);
          if (isMissingPrinter.length > 0) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "There is sub menu without selecting printer",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            return;
          }
        }

        await axios.put(`${apiBaseUrl}/api/products/edit-product`, {
          ...value,
          slug,
          productId: editItem._id,
          image: finalImageUrl,
          subMenu: subMenu,
          productIcon: selectedIcons || null,
          userId: userId || null
        });
        // message.success('Food Updated Successfully')
        Swal.fire({
          title: "Success",
          text: "Food/Drink Updated Successfully",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllItems();
        setCountImage(0);
        setOriginalImageURLEdit(null);
        setEditItem(null);
        setPopupModal(false);
        setFileList([]);
        setSubMenu([]);
        setSubMenuGroup("");
        setSubMenuPrinter([]);
        setSubMenuItem([]);
        setSubMenuSelectionType("");
        setSubMenuShowType("");
        setIsSubMenuPrintEnabled(false);
        setSubMenuRequirement("");
      } catch (error) {
        // message.error('Something Went Wrong')
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something Went Wrong",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  //handle delete
  const handleDelete = async (record) => {
    try {

      const auth = JSON.parse(localStorage.getItem("auth"));
      const decoded = auth?.token ? jwtDecode(auth.token) : null;
      const userId = decoded?.userId || currentUser || "Unknown";
      //console.log("Userdelete", userId)

      await axios.post(`${apiBaseUrl}/api/products/delete-product`, {
        productId: record._id,
        userId: userId,

      });
      // message.success('Food Deleted Successfully')
      Swal.fire({
        title: "Success",
        text: "Food/Drink Deleted Successfully",
        toast: true,
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      getAllItems();
      setPopupModal(false);
    } catch (error) {
      message.success("Something Went Wrong");
      console.log(error);
    }
  };

  const handleCancel = async () => {
    // Prevent canceling if upload is still in progress
    if (isUploading) {
      message.error(
        "Please wait until the image upload is complete before canceling."
      );
      return;
    }

    if (loading) {
      message.warning("Proceed submitting...");
      return;
    }

    // try {

    // } catch (error) {
    //   message.error("Something went wrong.");
    // } finally {
    // Reset states after canceling
    // setCountImage(0);
    setOriginalImageURLEdit(null);
    setFile(null);
    setImageUrl(null);
    setFileList([]);
    setEditItem(null); // Clear the edit state
    setSubMenu([]);
    setSubMenuGroup("");
    setSubMenuItem([]);
    setSubMenuSelectionType("");
    setSubMenuShowType("");
    setSubMenuRequirement("");
    setSubMenuPrinter([]);
    setPopupModal(false); // Close the modal
    setIsSubMenuPrintEnabled(false);

    // }
  };

  const handleImageUpload = async (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      message.error("Invalid file type. Only JPG, JPEG and PNG are allowed.");
      return;
    }

    // Check if file size exceeds 20MB
    if (file.size > 20 * 1024 * 1024) {
      message.error(
        "File size exceeds 20MB limit. Please choose a smaller file."
      );
      return;
    }

    // Initialize the file with status 'uploading' and 0% progress for preview purposes
    setFileList((prevList) => [
      ...prevList,
      {
        uid: file.uid,
        name: file.name,
        status: "uploading", // Image is uploading
        percent: 0, // Set progress to 0 initially
      },
    ]);

    setIsUploading(true); // Set uploading to true

    // Compress the image before upload
    const options = {
      maxSizeMB: 1, // Adjust compression size (1MB target)
      maxWidthOrHeight: 1920, // Optionally resize to max dimensions
      useWebWorker: true,
    };

    let compressedFile;
    let timeout;

    try {
      compressedFile = await imageCompression(file, options);
    } catch (err) {
      message.error("Image compression failed.");
      setIsUploading(false);
      return;
    }

    try {
      // Create a local object URL for preview purposes
      const localUrl = URL.createObjectURL(compressedFile);
      setImageUrl(localUrl); // Set the image URL for preview
      setFile(compressedFile);

      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid
            ? { ...item, status: "done", url: localUrl }
            : item
        )
      );
      message.success("Image ready for upload!");

      // Start a timeout for the upload process
      timeout = setTimeout(() => {
        message.error("Upload is taking too long. Please try again.");
        setIsUploading(false);
        setFileList((prevList) =>
          prevList.map((item) =>
            item.uid === file.uid ? { ...item, status: "error" } : item
          )
        );
      }, 30000); // 30 seconds timeout
      setUploadTimeout(timeout); // Store the timeout ID
    } catch (error) {
      message.error("Image upload failed! Please try again.");
      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid ? { ...item, status: "error" } : item
        )
      );
    } finally {
      // Ensure timeout is cleared after handling the upload result
      if (timeout) {
        clearTimeout(timeout);
      }
      setIsUploading(false); // Reset uploading status
    }
  };

  const uploadImageToS3 = async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file); // Append the file object directly

      const response = await axios.post(
        `${apiBaseUrl}/api/image/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data && response.data.url) {
        message.success("Image uploaded successfully!");
        return response.data.url; // Return the URL of the uploaded image
      } else {
        // If the response is invalid or does not contain the URL
        throw new Error("Failed to upload image. Please try again.");
      }
    } catch (error) {
      // message.error(error.response?.data?.message || "Image upload failed. Please try again.");
      console.error("Image upload error:", error);
      throw error; // Re-throw the error to be caught in the outer try-catch
    }
  };

  const handleStatusToggle = async (checked, record) => {
    try {
      await axios.put(`${apiBaseUrl}/api/products/edit-product`, {
        ...record,
        status: checked,
        productId: record._id,
      });
      setItemsData((prev) =>
        prev.map((item) =>
          item._id === record._id ? { ...item, status: checked } : item
        )
      );
      setFilteredItemsData((prev) =>
        prev.map((item) =>
          item._id === record._id ? { ...item, status: checked } : item
        )
      );
      message.success(
        `Menu Item Is Now ${checked ? "Available" : "Unavailable"}`
      );
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  return (
    <DefaultLayout searchPlaceholder="Name / Category" onSearch={handleSearch}>
      {/* Main content wrapper for blur effect */}
      <div className={`item-page-wrapper${popupModal || subMenuModalVisible || itemModalVisible || isEditing || isItemEditing ? ' blur-background' : ''}`}>
        <div className="page-header">
          <h1 className="page-title">Menu</h1>
          <Button type="primary" onClick={() => setPopupModal(true)}>
            Add Menu
          </Button>
        </div>
      </div>

      {/* <div>
        <h1>Menu List</h1>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <Search
            placeholder="Search"
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
            allowClear
          />

          <Button type="primary" onClick={() => setPopupModal(true)}>
            Add Menu
          </Button>
        </div>
      </div> */}

      <Table columns={columns} dataSource={filteredItemsData} bordered
        //add pagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: filteredItemsData.length > 10,
          showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
          onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
        }}
      />

      {popupModal && (
        <Modal
          // title={`${editItem !== null ? 'Edit Menu' : 'Add New Menu'}`}
          title={
            <div>
              {editItem !== null ? "Edit Menu" : "Add New Menu"}
              <CloseButton
                onClick={() => {
                  setEditItem(null);
                  setPopupModal(false);
                  handleCancel();
                }}
              />
            </div>
          }
          open={popupModal}
          onCancel={handleCancel}
          footer={false}
          width={1000}
        >
          <Form
            // form={form}
            layout="vertical"
            initialValues={{
              ...editItem,
              productIcon: Array.isArray(editItem?.productIcon) && editItem.productIcon.length > 0
                ? editItem.productIcon.map(icon => icon._id)
                : []
            }}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="name"
              label="Name"
              rules={[
                { required: true, message: "Please enter the name" },
                { min: 3, message: "Name must be at least 3 characters" },
                {
                  validator: (_, value) => {
                    const isDuplicate = itemsData.some(
                      (item) =>
                        item.name === value && (!editItem || item._id !== editItem._id)
                    );
                    if (isDuplicate) {
                      return Promise.reject(
                        new Error("This name already exists!")
                      );
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input onChange={handleNameChange} />
            </Form.Item>

            <Form.Item
              name="slug"
              label="Slug"
              rules={[
                { required: true, message: "Please enter a slug" },
                { min: 3, message: "Slug must be at least 3 characters" },
                {
                  validator: (_, value) => {
                    const isDuplicate = itemsData.some(
                      (item) =>
                        item.slug === value && (!editItem || item._id !== editItem._id)
                    );
                    if (isDuplicate) {
                      return Promise.reject(
                        new Error("This slug already exists!")
                      );
                    }
                    return Promise.resolve();
                  }
                }
              ]}
              extra={<span style={{ fontSize: 12, color: '#888' }}>Slug is used in order chit for the Kitchen.</span>}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              rules={[
                { required: true, message: "Please enter a description" },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>


            <Form.Item
              name="productIcon"
              label="Product Icon"
            >
              <Select
                mode="multiple"
                onDropdownVisibleChange={handleProductIconDropdownVisibleChange}
                suffixIcon={productIconOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                value={editItem?.productIcon?.map(icon => icon._id) || []}
              >
                {icons.map((icon) => (
                  <Select.Option key={icon._id} value={icon._id} label={icon.iconName}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <i
                        className={icon.faIcon}
                        style={{
                          fontSize: 20,
                          color: icon.iconColor,
                          width: '24px',
                          textAlign: 'center'
                        }}
                      />
                      <div>
                        <div>{icon.iconName}</div>
                      </div>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="price"
              label="Price"
              rules={[
                { required: true, message: "Please enter the price" },
                {
                  pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                  message: "Please enter a valid price",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="discountAble"
              label="Discountable"
              valuePropName="checked"
              initialValue={false}
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="quantity"
              label={
                <span>
                  Max Quantity
                  <Tooltip title="Leave Empty for No Quantity Limitation (Unlimited Inventory)">
                    <QuestionCircleOutlined
                      style={{
                        marginLeft: 8,
                        color: "#999",
                        fontSize: "1.5em",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              extra={<span style={{ fontSize: 12, color: '#888' }}>Leave empty for no quantity limitation (unlimited inventory).</span>}
              rules={[
                {
                  required: false,
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === "") {
                      return Promise.resolve();
                    }
                    return /^[0-9]+$/.test(value)
                      ? Promise.resolve()
                      : Promise.reject("Quantity must be a number or empty");
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>

            {/* <Form.Item
              label={
                <span>
                  Quantity 1 equal to
                  <Tooltip title="For Inventory Use (Example: 1 quantity = 300ml or 2pcs.)">
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: "#999", fontSize: "1.5em" }}
                    />
                  </Tooltip>
                </span>
              }
              style={{ marginBottom: 0 }}
            >
              <Input.Group compact>
                <Form.Item
                  name={['quantitySet', 'unit']}
                  noStyle
                  rules={[{ required: true, message: 'Please input unit value' }]}
                >
                  <Input style={{ width: '60%' }} placeholder="e.g. 300" />
                </Form.Item>
                <Form.Item
                  name={['quantitySet', 'quantifier']}
                  noStyle
                  rules={[{ required: true, message: 'Please select quantifier' }]}
                >
                 <Select
                  placeholder="Select unit"
                  style={{ width: '40%' }}
                  options={[
                    { label: 'ml', value: 'ml' },
                    { label: 'pcs', value: 'pcs' },
                    { label: 'g', value: 'g' },
                    { label: 'pack', value: 'pack' },
                  ]}
                />
                </Form.Item>
              </Input.Group>
            </Form.Item> */}

            <Form.Item
              label={
                <span>
                  Unit of Measure
                  <Tooltip title="For Inventory Use (Example: ml, pcs.)">
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: "#999", fontSize: "1.5em" }}
                    />
                  </Tooltip>
                </span>
              }
              name="uom"
              rules={[{ required: true, message: 'Please input or select a unit' }]}
              getValueFromEvent={(value) => value}

            >
              <AutoComplete
                placeholder="Type or select unit (e.g., ml, bottle, orz)"
                value={uom}
                noStyle
                onChange={(value) => setUom(value)}
                allowClear
                options={[
                  { value: 'ml' },
                  { value: 'l' },
                  { value: 'shot' },
                  { value: 'glass' },
                  { value: 'bottle' },
                  { value: 'can' },
                  { value: 'pack' },
                  { value: 'g' },
                  { value: 'kg' },
                  { value: 'pcs' },
                ]}
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Quantity per 1 unit
                  <Tooltip title="For Inventory Use (Example: 1 quantity = 300ml or 2pcs.)">
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: "#999", fontSize: "1.5em" }}
                    />
                  </Tooltip>
                </span>
              }
            >
              <Form.Item
                name='quantityUnit'
                noStyle
                rules={[{ message: 'Please input unit value' }]}
              >
                <Input placeholder="e.g. 300" />
              </Form.Item>
            </Form.Item>


            <Form.Item name="image" label="Image Upload">
              {/* handle previous image */}
              <Upload
                className="upload-container"
                listType="picture"
                fileList={fileList}
                customRequest={({ file }) => handleImageUpload(file)}
                onRemove={async (file) => {
                  if (isUploading) {
                    message.warning(
                      "Please wait until the upload is complete before removing the file."
                    );
                    return false; // Prevent the removal
                  }

                  if (file.url && editItem) {
                    setFileList([]);
                  }
                  // if (file.url && previousImageKey &&!editItem) {
                  //   try {
                  //     // console.log("Deleting previous image key:", previousImageKey);
                  //     await deleteImageFromS3(previousImageKey);
                  //     setPreviousImageKey(null);
                  //     // message.success("Image removed successfully!");
                  //   } catch (error) {
                  //     // console.error("Failed to delete image:", error);
                  //     // message.error("Failed to remove image.");
                  //   }
                  // }
                  setFile(null);
                  setFileList([]);
                  setImageUrl(null);
                }}
              >
                {fileList.length < 1 && (
                  <Button icon={<UploadOutlined />} className="upload-button">
                    Upload Image
                  </Button>
                )}
              </Upload>
            </Form.Item>

            {/* <Form.Item
                name="image"
                label="Image URL"
                rules={[
                  { required: true, message: 'Please enter an image URL' },
                  { type: 'url', message: 'Please enter a valid URL' },
                ]}
              >
                <Input />
              </Form.Item>


              <Form.Item name="pid" label="pid" hidden>
                <Input value={newPid} />
              </Form.Item> */}

            {/* <Form.Item
                name="category"
                label="Category"
                rules={[
                  { required: true, message: 'Please select a category' },
                ]}
              >
                <Select>
                  {categories.map((category) => (
                    <Select.Option key={category._id} value={category.name}>
                      {category.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
            <Form.Item
              name="category"
              label="Category"
              rules={[{ required: true, message: "Please select a category" }]}
            >
              <Select
                onDropdownVisibleChange={handleCategoryDropdownVisibleChange}
                suffixIcon={
                  categoryOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
              >
                {categories.map((category) => (
                  <Select.Option key={category._id} value={category.name}>
                    {category.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="isSubMenuPrint"
              label="Print Sub Menu Individually"
              valuePropName="checked"
            >
              <Switch onChange={(checked) => setIsSubMenuPrintEnabled(checked)} />
            </Form.Item>


            <Form.Item
              name="tableDisableList"
              label="Disable for Iron Plate Table"
            >
              <Select
                mode="multiple"
                onDropdownVisibleChange={handleTableDisableListVisibleChange}
                suffixIcon={tableDisableList ? <CaretUpOutlined /> : <CaretDownOutlined />}
                value={editItem?.tableDisableList?.map(tableList => tableList.table_number) || []}
              >
                {tableList.map((table) => (
                  <Select.Option key={table.table_number} value={table.table_number} label={table.table_number}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div>
                        <div>{table.table_number}</div>
                      </div>
                    </div>
                  </Select.Option>
                ))}
              </Select>

            </Form.Item>

            <Form.Item label="Sub Menu" name="subMenu">
              <div>
                <Button
                  type="default"
                  onClick={openSubMenuModal}
                  style={{ marginTop: "10px", width: "100%" }}
                >
                  Add Sub Menu
                </Button>

                <br />

                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    border: "1px solid #ccc",
                    marginTop: "10px",
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#f9f9f9" }}>
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Group
                        </th>
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Items
                        </th>
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Selection Type
                        </th>
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Show Type
                        </th>
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Requirement
                        </th>
                        {isSubMenuPrintEnabled && (
                          <th
                            style={{ padding: "8px", border: "1px solid #ccc" }}
                          >
                            Printer
                          </th>
                        )}
                        <th
                          style={{ padding: "8px", border: "1px solid #ccc" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {subMenu.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            style={{ textAlign: "center", padding: "16px" }}
                          >
                            <Empty className="noData" description="No Data" />
                          </td>
                        </tr>
                      ) : (
                        subMenu.map((menu, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {menu.group}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <ul>
                                {menu.items.map((item) => (
                                  <li key={item.name}>
                                    {item.name}: {symbol}{" "}
                                    {parseFloat(item.price).toFixed(2)}
                                  </li>
                                ))}
                              </ul>
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {menu.selection === "single"
                                ? "Single"
                                : menu.selection === "multiple"
                                  ? "Multiple"
                                  : menu.selection === "compulsory"
                                    ? "Compulsory"
                                    : ""}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {menu.show === null || menu.show === undefined
                                ? ""
                                : menu.show
                                  ? "Show"
                                  : "Not Show"}
                            </td>

                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {menu.requirement === "required"
                                ? "Required"
                                : menu.requirement === "not_required"
                                  ? "Not Required"
                                  : ""}
                            </td>
                            {isSubMenuPrintEnabled && (
                              <td
                                style={{
                                  padding: "8px",
                                  border: "1px solid #ccc",
                                }}
                              >
                                {menu.printer ? (Array.isArray(menu.printer) ? menu.printer.map(pId => printersData.find(p => p.id == pId)?.name).filter(Boolean).join(", ") : printersData.find(printer => printer.id == menu.printer)?.name) : 'n/a'}
                              </td>
                            )}
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <EditOutlined
                                style={{ cursor: "pointer", fontSize: 16 }}
                                onClick={() => openEditModal(menu.id)}
                              />
                              <Popconfirm
                                title="Are you sure you want to delete?"
                                onConfirm={() => handleDeleteSubMenu(menu.id)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <DeleteOutlined
                                  style={{ cursor: "pointer", fontSize: 16 }}
                                />
                              </Popconfirm>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Add item Modal */}
              <Modal
                title={
                  <div>
                    Add Item
                    <CloseButton onClick={handleCancelItemModal} />
                  </div>
                }
                open={itemModalVisible}
                onOk={handleAddItem}
                onCancel={handleCancelItemModal}
                getContainer={document.body}
                zIndex={1009}
              >
                <Form layout="vertical">
                  <Form.Item label="Add Items From" required>
                    <Radio.Group
                      value={addItemMode}
                      onChange={(e) => setAddItemMode(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <Radio value="custom">Custom Options</Radio>
                      <Radio value="category">Existing Category</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {addItemMode === "category" ? (
                    <>
                      <Form.Item label="Select Category" required>
                        <Select
                          value={selectedCategory}
                          onChange={(value) => setSelectedCategory(value)}
                          placeholder="Choose a category to add all its items"
                          style={{ width: '100%' }}
                          allowClear
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        >
                          {getUniqueCategories().map((category) => (
                            <Select.Option key={category} value={category}>
                              {category}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>

                    </>
                  ) : (
                    <>
                      <Form.Item label="Item Name" required>
                        <AutoComplete
                          value={newItemName}
                          open={dropdownOpen}
                          onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                          onChange={(value) => {
                            setNewItemName(value);
                            // Clear selected menu item when user types custom text
                            setSelectedMenuItem(null);
                            // Keep dropdown open while typing
                            setDropdownOpen(true);
                          }}
                          onSelect={(value, option) => {
                            // User selected from menu items
                            const selectedItem = option.item;
                            setNewItemName(selectedItem.name);
                            setSelectedMenuItem(selectedItem);
                            // Auto-fill price if not already set
                            //  if (!newItemPrice || newItemPrice === 0) {
                            //    setNewItemPrice(selectedItem.price || 0);
                            //  }
                            // Close dropdown after selection
                            setDropdownOpen(false);
                          }}
                          onFocus={() => {
                            // Show dropdown when focused
                            setDropdownOpen(true);
                          }}
                          onBlur={() => {
                            // Close dropdown when focus is lost (with a small delay)
                            setTimeout(() => setDropdownOpen(false), 200);
                          }}
                          placeholder="Type custom option or search menu items (e.g., Hot, Cold, Less Spicy)"
                          allowClear
                          style={{ width: '100%' }}
                          filterOption={(inputValue, option) => {
                            if (!inputValue) return true; // Show all options when input is empty
                            const itemName = option.value?.toLowerCase() || '';
                            const category = option.item?.category?.toLowerCase() || '';
                            const searchTerm = inputValue.toLowerCase();
                            return itemName.includes(searchTerm) || category.includes(searchTerm);
                          }}
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          options={itemsData.map((item) => ({
                            value: item.name,
                            label: (
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>{item.name}</span>
                                <span style={{ color: '#666', fontSize: '12px' }}>
                                  {item.category} - {symbol}{parseFloat(item.price || 0).toFixed(2)}
                                </span>
                              </div>
                            ),
                            item: item
                          }))}
                        />
                        {selectedMenuItem && (
                          <div style={{ marginTop: '4px', fontSize: '12px', color: '#52c41a' }}>
                            ✓ Selected from menu: {selectedMenuItem.category} - {symbol}{parseFloat(selectedMenuItem.price || 0).toFixed(2)}
                          </div>
                        )}
                      </Form.Item>
                      <Form.Item label="Item Price" required>
                        <Input
                          type="number"
                          value={newItemPrice}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              !value.includes(".") ||
                              value.split(".")[1].length <= 2
                            ) {
                              setNewItemPrice(Math.max(0, Number(value)));
                            }
                          }}
                          min={0}
                        />
                      </Form.Item>

                      <Form.Item label="Custom Unit" required>
                        <Input
                          type="number"
                          value={newCustomUnit}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setNewCustomUnit("");
                              return;
                            }
                            if (
                              !value.includes(".") ||
                              value.split(".")[1].length <= 2
                            ) {
                              setNewCustomUnit(Math.max(0, Number(value)));
                            }
                          }}
                          min={0}
                          addonAfter={selectedMenuItem?.uom || ""}
                          allowClear
                        />
                        {selectedMenuItem && (
                          <div style={{ marginTop: '4px', fontSize: '12px', color: '#52c41a', whiteSpace: 'pre-line' }}>
                            ✓ Default Quantity per 1 Unit for Selected Menu: {selectedMenuItem.quantityUnit || 0} {selectedMenuItem.uom || ""}
                          </div>
                        )}
                      </Form.Item>
                    </>
                  )}
                </Form>
              </Modal>

              {/* Add Sub Menu Modal */}
              <Modal
                title={
                  <div>
                    Add Sub Menu
                    <CloseButton
                      onClick={() => {
                        setSubMenuModalVisible(false);
                        setSubMenuGroup("");
                        setSubMenuPrinter([]);
                        setSubMenuItem([]);
                      }}
                    />
                  </div>
                }
                open={subMenuModalVisible}
                onOk={handleSubMenuSubmit}
                onCancel={() => {
                  setSubMenuModalVisible(false);
                  setSubMenuGroup("");
                  setSubMenuPrinter([]);
                  setSubMenuItem([]);
                }}
                zIndex={1005}

              >
                <Form layout="vertical">
                  <Form.Item label="Group" required>
                    <Input
                      value={subMenuGroup}
                      onChange={handleSubMenuGroupChange}
                    />
                  </Form.Item>

                  <Form.Item label="Items" required>
                    <Button
                      type="default"
                      onClick={openAddItemModal}
                      style={{ marginTop: "10px", width: "100%" }}
                    >
                      Add Items
                    </Button>

                    <div
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        border: "1px solid #ccc",
                        marginTop: "10px",
                      }}
                    >
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#f9f9f9" }}>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Name
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Price
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Custom Unit
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {subMenuItem.length === 0 ? (
                            <tr>
                              <td
                                colSpan="3"
                                style={{ textAlign: "center", padding: "16px" }}
                              >
                                <Empty
                                  className="noData"
                                  description="No Data"
                                />
                              </td>
                            </tr>
                          ) : (
                            subMenuItem.map((item, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {item.name}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {parseFloat(item.price).toFixed(2)}
                                </td>
                                {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                    <DeleteOutlined 
                        style={{ cursor: 'pointer' }} 
                        onClick={() => handleDeleteSubMenuItem(index)} 
                    />
                </td> */}
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {parseFloat(item.customUnit).toFixed(2)}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  <EditOutlined
                                    style={{ cursor: "pointer", fontSize: 20 }}
                                    onClick={() => openEditItemModal(item.id)}
                                  />
                                  <Popconfirm
                                    title="Are you sure you want to delete?"
                                    onConfirm={() => handleDeleteItem(item.id)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <DeleteOutlined
                                      style={{
                                        cursor: "pointer",
                                        fontSize: 20
                                      }}
                                    />
                                  </Popconfirm>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Form.Item>

                  <Form.Item label="Selection Type" required>
                    <Radio.Group
                      value={subMenuSelectionType}
                      onChange={(e) => {
                        const value = e.target.value;
                        handleSubMenuSelectionTypeChange(e);

                        if (value === "compulsory") {
                          handleSubMenuRequirementChange({ target: { value: "not_required" } });
                          //setSubMenuShowType(true);
                        } else {
                          setSubMenuShowType(true);
                        }
                      }}
                    >
                      <Radio value="multiple">Multiple Selection</Radio>
                      <Radio value="single">Single Selection</Radio>
                      <Radio value="compulsory">Compulsory Selection</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item
                    label="Requirement"
                    required={subMenuSelectionType !== "compulsory"}
                  >
                    <Radio.Group
                      value={subMenuRequirement}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSubMenuRequirement(value);
                      }}
                      disabled={subMenuSelectionType === "compulsory"}
                    >
                      <Radio value="required">Required</Radio>
                      <Radio value="not_required">Not Required</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item label="Show Type" required>
                    <Radio.Group
                      value={subMenuShowType}
                      onChange={(e) => setSubMenuShowType(e.target.value)}
                      disabled={
                        subMenuRequirement === "required" ||
                        subMenuSelectionType !== "compulsory"
                      }
                    >
                      <Radio value={true}>Show</Radio>
                      <Radio value={false}>Not Show</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {isSubMenuPrintEnabled && (
                    <Form.Item
                      name="printer"
                      label="Printer"
                      rules={[{ required: true, message: 'Please select the printer!' }]}
                    >
                      <Select
                        onDropdownVisibleChange={handlePrinterStatusDropdownVisibleChange}
                        suffixIcon={printerStatusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        onChange={handleSubMenuPrinterChange}
                        value={subMenuPrinter}

                        mode="multiple"
                      >
                        {printersData.map((printer) => (
                          <Select.Option key={printer.id} value={printer.id}>
                            {printer.name}
                          </Select.Option>
                        ))}
                      </Select>

                    </Form.Item>
                  )}
                </Form>
              </Modal>

              {/* edit item Modal */}
              <Modal
                title={
                  <div>
                    Edit Item
                    <CloseButton onClick={() => setIsItemEditing(false)} />
                  </div>
                }
                open={isItemEditing}
                onOk={handleEditItemSave}
                onCancel={() => setIsItemEditing(false)}
                getContainer={document.body}
                zIndex={1009}
              >
                <Form layout="vertical">
                  <>
                    <Form.Item label="Item Name" required>
                      <AutoComplete
                        value={editItemName}
                        open={editDropdownOpen}
                        onDropdownVisibleChange={(open) => setEditDropdownOpen(open)}
                        onChange={(value) => {
                          setEditItemName(value);
                          setSelectedEditMenuItem(null);
                          setEditDropdownOpen(true);
                        }}
                        onSelect={(value, option) => {
                          const selectedItem = option.item;
                          setEditItemName(selectedItem.name);
                          setSelectedEditMenuItem(selectedItem);
                          // setEditItemPrice(selectedItem.price || 0);
                          setEditDropdownOpen(false);
                        }}
                        onFocus={() => setEditDropdownOpen(true)}
                        onBlur={() => setTimeout(() => setEditDropdownOpen(false), 200)}
                        placeholder="Type or search menu items"
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        allowClear
                        style={{ width: '100%' }}
                        filterOption={(inputValue, option) => {
                          if (!inputValue) return true;
                          const itemName = option.value?.toLowerCase() || '';
                          const category = option.item?.category?.toLowerCase() || '';
                          const searchTerm = inputValue.toLowerCase();
                          return itemName.includes(searchTerm) || category.includes(searchTerm);
                        }}
                        options={itemsData.map((item) => ({
                          value: item.name,
                          label: (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span>{item.name}</span>
                              <span style={{ color: '#666', fontSize: '12px' }}>
                                {item.category} - {symbol}{parseFloat(item.price || 0).toFixed(2)}
                              </span>
                            </div>
                          ),
                          item: item,
                        }))}
                      />
                      {selectedEditMenuItem && (
                        <div style={{ marginTop: '4px', fontSize: '12px', color: '#52c41a' }}>
                          ✓ Selected from menu: {selectedEditMenuItem.category} - {symbol}
                          {parseFloat(selectedEditMenuItem.price || 0).toFixed(2)}
                        </div>
                      )}
                    </Form.Item>

                    <Form.Item label="Item Price" required>
                      <Input
                        type="number"
                        value={editItemPrice}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!value.includes('.') || value.split('.')[1].length <= 2) {
                            setEditItemPrice(Math.max(0, Number(value)));
                          }
                        }}
                        min={0}
                      />
                    </Form.Item>
                    <Form.Item label="Custom Unit" required>
                      <Input
                        type="number"
                        value={editCustomUnit}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "") {
                            setEditCustomUnit("");
                            return;
                          }
                          if (!value.includes('.') || value.split('.')[1].length <= 2) {
                            setEditCustomUnit(Math.max(0, Number(value)));
                          }
                        }}
                        min={0}
                        addonAfter={selectedMenuItem?.uom || ""}
                        allowClear
                      />
                      {selectedMenuItem && (
                        <div style={{ marginTop: '4px', fontSize: '12px', color: '#52c41a', whiteSpace: 'pre-line' }}>
                          ✓ Default Quantity per 1 Unit for Selected Menu: {selectedMenuItem.quantityUnit || 0} {selectedMenuItem.uom || ""}
                        </div>
                      )}
                    </Form.Item>
                  </>
                </Form>
              </Modal>

              {/* Edit Sub Menu Modal */}
              <Modal
                title={
                  <div>
                    Edit Sub Menu
                    <CloseButton onClick={() => setIsEditing(false)} />
                  </div>
                }
                open={isEditing}
                onOk={handleEditModalSave}
                onCancel={() => setIsEditing(false)}
                zIndex={1005}
              >
                <Form layout="vertical">
                  <Form.Item label="Group" required>
                    <Input
                      value={editSubMenuGroup}
                      onChange={(e) => setEditSubMenuGroup(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item label="Items" required>
                    <Button
                      type="default"
                      onClick={openAddItemModal}
                      style={{ marginTop: "10px", width: "100%" }}
                    >
                      Add Items
                    </Button>

                    <div
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        border: "1px solid #ccc",
                        marginTop: "10px",
                      }}
                    >
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#f9f9f9" }}>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Name
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Price
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Custom Unit
                            </th>
                            <th
                              style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                              }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {subMenuItem.length === 0 ? (
                            <tr>
                              <td
                                colSpan="3"
                                style={{ textAlign: "center", padding: "16px" }}
                              >
                                <Empty
                                  className="noData"
                                  description="No Data"
                                />
                              </td>
                            </tr>
                          ) : (
                            subMenuItem.map((item, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {item.name}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {parseFloat(item.price).toFixed(2)}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {parseFloat(item.customUnit).toFixed(2)}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {/* <EditOutlined style={{ cursor: "pointer" }} onClick={() => item.id} /> */}
                                  <EditOutlined
                                    style={{ cursor: "pointer", fontSize: 20 }}
                                    onClick={() => openEditItemModal(item.id)}
                                  />
                                  <Popconfirm
                                    title="Are you sure you want to delete?"
                                    onConfirm={() => handleDeleteItem(item.id)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <DeleteOutlined
                                      style={{
                                        cursor: "pointer",
                                        fontSize: 20
                                      }}
                                    />
                                  </Popconfirm>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Form.Item>

                  <Form.Item label="Selection Type" required>
                    <Radio.Group
                      value={editSubMenuSelectionType}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEditSubMenuSelectionType(value);

                        if (value === "compulsory") {
                          setEditSubMenuRequirement("not_required");
                        } else {
                          setEditSubMenuShowType(true);
                        }
                      }}
                    >
                      <Radio value="multiple">Multiple Selection</Radio>
                      <Radio value="single">Single Selection</Radio>
                      <Radio value="compulsory">Compulsory Selection</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item
                    label="Requirement"
                    required={editSubMenuSelectionType !== "compulsory"}
                  >
                    <Radio.Group
                      value={editSubMenuRequirement}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEditSubMenuRequirement(value);

                        // if (value === "required") {
                        //   setEditSubMenuShowType("true");
                        // }
                      }}
                      disabled={editSubMenuSelectionType === "compulsory"}
                    >
                      <Radio value="required">Required</Radio>
                      <Radio value="not_required">Not Required</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item label="Show Type" required>
                    <Radio.Group
                      value={editSubMenuShowType}
                      onChange={(e) => setEditSubMenuShowType(e.target.value)}
                      disabled={
                        editSubMenuRequirement === "required" ||
                        editSubMenuSelectionType !== "compulsory"
                      }
                    >
                      <Radio value={true}>Show</Radio>
                      <Radio value={false}>Not Show</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {isSubMenuPrintEnabled && (
                    <Form.Item
                      label="Printer"
                      rules={[{ required: true, message: 'Please select the printer!' }]}
                    >
                      <Select
                        onDropdownVisibleChange={handlePrinterStatusDropdownVisibleChange}
                        suffixIcon={printerStatusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        onChange={(e) => setEditSubMenuPrinter(e)}
                        value={editSubMenuPrinter}
                        mode="multiple"
                      >
                        {printersData.map((printer) => (
                          <Select.Option key={printer.id} value={printer.id}>
                            {printer.name}
                          </Select.Option>
                        ))}
                      </Select>

                    </Form.Item>
                  )}
                </Form>
              </Modal>
            </Form.Item>



            {/* <Form.Item
                name="status"
                label="Availability"
                rules={[
                  { required: true, message: 'Please select availability status' },
                ]}
              >
                <Select>
                  <Select.Option value={true}>Available</Select.Option>
                  <Select.Option value={false}>Not Available</Select.Option>
                </Select>
              </Form.Item> */}
            <Form.Item
              name="status"
              label="Availability"
              rules={[
                {
                  required: true,
                  message: "Please select availability status",
                },
              ]}
              initialValue={true}
            >
              <Select
                onDropdownVisibleChange={handleStatusDropdownVisibleChange}
                suffixIcon={
                  statusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
              >
                <Select.Option value={true}>Available</Select.Option>
                <Select.Option value={false}>Not Available</Select.Option>
              </Select>
            </Form.Item>

            {/* <Form.Item name="createdAt" label="Created At" hidden>
                <Input value={new Date()} />
              </Form.Item> */}

            <div className="d-flex justify-content-end ant-modal-footer">
              {/* <Button type="primary" htmlType="submit">
                  Save
                </Button> */}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading} // Show loading spinner
                // iconPosition="start"  // Ensure the icon is positioned at the start
                disabled={loading} // Disable the button while loading
              >
                Save
              </Button>
            </div>
          </Form>
        </Modal>

      )}

      {/* image modal */}
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
        transitionName=""  // 禁用动画
        maskTransitionName=""  // 禁用遮罩动画
        width={400}
        bodyStyle={{
          padding: 0,
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
        }}
        style={{
          top: '30%',  // 确保 Modal 整体居中
          transform: 'translateY(-10%)',  // 修正垂直偏移
          opacity: previewVisible ? 1 : 1, // 避免淡入动画
          pointerEvents: previewVisible ? 'auto' : 'none',
        }}
      >
        <img
          alt="item"
          style={{
            width: '100%',
            maxWidth: 400,
            maxHeight: 400,
            objectFit: 'contain',
            display: 'block'
          }}
          src={previewImage}
        />
      </Modal>
    </DefaultLayout>
  );
};

export default ProductsTable;
